module.exports = __webpack_public_path__ + "img/Prong Too Long.6680e8f2.png";